
import { React, useState, useEffect } from "react";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { LineChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { useWindowSize } from "services/resizeservice";
import {
  getDate,
  getTime,
  getDay,
  formatYaxisNumber,
} from "components/common/dateTime";

function SwappingComponent(props) {
  const [echartInstance, setEchartInstance] = useState(null);
  const size = useWindowSize();

  useEffect(() => {
    echartInstance?.resize();
  }, [size.width]);

  echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LineChart,
    CanvasRenderer,
  ]);

  var xAxisData = [];
  var yAxisSwapping = [];

  if (props.data != undefined) {
    props.data.map(function (obj) {
      if (props.selectValue === "HOUR_24" || props.selectValue === "HOUR_12") {
        xAxisData.push(getTime(obj.endDate));
      } else if (props.selectValue === "WEEK") {
        xAxisData.push(getDay(obj.endDate));
      } else {
        xAxisData.push(getDate(obj.endDate));
      }
      yAxisSwapping.push(obj.swaps);
    });
  }

  if (props.selectValue == "168") {
    xAxisData = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  }

  // const data = {
  //   statusCode: 200,
  //   message: "Swaps Data",
  //   error: false,
  //   data: [
  //     {
  //       startDate: 1654239613,
  //       endDate: 1654153213,
  //       swaps: "10",
  //     },
  //     {
  //       startDate: 1654153213,
  //       endDate: 1654066813,
  //       swaps: "20",
  //     },
  //     {
  //       startDate: 1654066813,
  //       endDate: 1653980413,
  //       swaps: "30",
  //     },
  //     {
  //       startDate: 1653980413,
  //       endDate: 1653894013,
  //       swaps: "40",
  //     },
  //     {
  //       startDate: 1653894013,
  //       endDate: 1653807613,
  //       swaps: "50",
  //     },
  //     {
  //       startDate: 1653807613,
  //       endDate: 1653721213,
  //       swaps: "60",
  //     },
  //     {
  //       startDate: 1653721213,
  //       endDate: 1653634813,
  //       swaps: "70",
  //     },
  //   ],
  // };

  const options = () => ({
    tooltip: {
      trigger: "item",
    },
    grid: {
      left: "11%",
      right: "4%",
      bottom: "20%",
      containLabel: true,
      height: "70%",
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      name: "Time",
      nameLocation: "middle",
      // nameGap: 30,
      nameGap: xAxisData?.every((element) => element === null) ? 20 : 40,
      axisTick: {
        show: false,
      },
      splitLine: { show: true },
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
      axisLabel: {
        rotate:
          props.selectValue === "WEEK_2" ||
          props.selectValue === "MONTH" ||
          props.selectValue === "MONTH_3"
            ? 30
            : 0,
      }
    },
    yAxis: {
      type: "value",
      name: "Number of Swap",
      nameLocation: "middle",
      nameGap: 32,
      // min: 0,
      // max: 500,
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
      axisLabel: {
        formatter: formatYaxisNumber,
      },
    },
    series: [
      {
        name: "Time",
        // data: [50, 370, 70, 318, 135, 347, 160],
        data: yAxisSwapping,
        type: "line",
        symbol: "circle",
        symbolSize: 10,
        lineStyle: {
          color: "#23297A",
          width: 1.5,
        },
        itemStyle: {
          borderWidth: 0,
          borderColor: "#EE6666",
          color: "#23297A",
        },
      },
    ],
  });
  return (
    <ReactEcharts
      echarts={echarts}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      onChartReady={(instance) => {
        setEchartInstance(instance);
      }}
      opts={{ renderer: "svg" }}
      option={options()}
    />
  );
}
export default SwappingComponent;
